import React from 'react'
import { Link } from 'gatsby'
import { Col, Row, Text } from '@paypalcorp/pp-react'

import Computer from '../../../../../../icons/computer'
import CodeIcon from '../../../../../../icons/codeIcon'
import Laptop from '../../../../../../icons/laptop'

import './style.css'

const IconFiles = {
  Computer: <Computer />,
  CodeIcon: <CodeIcon />,
  Laptop: <Laptop />,
}

const IconCard = ({ tile }) => {
  return (
    <div className="iconCard">
      <Row>
        <Col md="2">
          <div className="iconCard-icon_wrapper">{IconFiles[tile.icon]}</div>
        </Col>
        <Col md="10">
          <h2 className="iconCard-header">{tile.title}</h2>
          <div>
            <Text className="iconCard-text">{tile.text}</Text>
          </div>
          <div>
            <Link href={tile.url} className="tanLink">
              {tile.linkText}
            </Link>
          </div>
        </Col>
      </Row>
    </div>
  )
}

export default IconCard
